export default {
  init() {
    // JavaScript to be fired on the about us page
    console.log('arranca el barcelonaaaa');

     function cambiarVideo() {
      let video = $('#my-video source').attr('src');
      let videoSrc = $('#my-video').data('video');
      console.log(videoSrc);
      console.log(video);
      let anchoPantalla =  $(window).width();
      if(anchoPantalla <= 768) {
        $('#my-video').attr('src', videoSrc); 
      } else {
        $('#my-video').attr('src', video) 
      }
    }

    cambiarVideo();

    $(window).on('resize',function() {
      cambiarVideo();
    });

    $('#quitar-mute').click( function (){
      if( $('video').prop('muted', true) )
      {
        $('video').prop('muted', false);
        $('#quitar-mute').css('display','none');
        $('#mute-video').css('display','block');
      }
    });

    $('#mute-video').click( function (){
      $('video').prop('muted', true);
      $('#quitar-mute').css('display','block');
      $('#mute-video').css('display','none');
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-entradasBarcelona.js